import * as React from 'react';
import {Building} from 'lucide-react';
import ResourceFigure from './ResourceFigure';

export default function BuildingResourceFigure({
	hasProducts = false,
	hasOffers = false,
	className,
}) {
	return (
		<ResourceFigure
			icon={Building}
			bgClassName={
				hasProducts
					? 'bg-fuchsia-50 border-fuchsia-300 rotate-45 scale-[0.9]'
					: hasOffers
					? 'bg-yellow-50 border-yellow-300 rotate-45 scale-[0.9]'
					: 'bg-stone-100 border-stone-300'
			}
			iconClassName={
				hasProducts
					? 'text-fuchsia-600'
					: hasOffers
					? 'text-yellow-600'
					: 'text-stone-600'
			}
			className={className}
		/>
	);
}
